"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7780],{

/***/ 87780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ AboutItem_AboutItem; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./components/StyledRichText/index.tsx + 3 modules
var StyledRichText = __webpack_require__(31585);
// EXTERNAL MODULE: ./theme/mixins/padding.ts
var padding = __webpack_require__(54986);
// EXTERNAL MODULE: ./components/Icons/Icon.tsx + 51 modules
var Icon = __webpack_require__(82218);
;// CONCATENATED MODULE: ./components/TechItem/TechItem.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 3.75rem;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  white-space: pre-line;\n  text-align: center;\n  line-height: 1.25rem;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}




const ItemContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f56ba205-0"
})(_templateObject());
const SvgContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f56ba205-1"
})(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.gfx.mixins.mb(1);
});
const Name = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-f56ba205-2"
})(_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.themeColorOpacities.fg70;
});
const TechItem = (param)=>{
    let { name  } = param;
    const determineSvgName = (name)=>{
        switch(name){
            case "D3":
                return "DTHREE";
            case "Ruby on Rails":
                return "RubyOnRails";
            case "React Native":
                return "ReactNative";
            case "Google Optimize":
                return "GoogleOptimize";
            case "Google Analytics":
                return "GoogleAnalytics";
            case "Three.js":
                return "Threejs";
            case "Next.js":
                return "Nextjs";
            default:
                return name;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    name: determineSvgName(name)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                children: name
            })
        ]
    });
};
/* harmony default export */ var TechItem_TechItem = (TechItem);

;// CONCATENATED MODULE: ./components/TechItem/index.ts


;// CONCATENATED MODULE: ./blocks/AboutItem/AboutItem.tsx

function AboutItem_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n"
    ]);
    AboutItem_templateObject = function() {
        return data;
    };
    return data;
}
function AboutItem_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    AboutItem_templateObject1 = function() {
        return data;
    };
    return data;
}
function AboutItem_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 53.75rem;\n"
    ]);
    AboutItem_templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: 1;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 3.75rem;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 1.5rem;\n  ",
        "\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    column-gap: 3rem;\n    row-gap: 2rem;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: repeat(6, auto);\n    justify-content: start;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: auto auto auto;\n  gap: 1rem;\n  justify-content: space-around;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 3.25rem 2.5rem;\n  "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  ",
        "\n  border-radius: 1.25rem;\n  padding: 2.5rem 1.5rem;\n\n  ",
        "\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}






const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4babb24b-0"
})(AboutItem_templateObject(), ()=>(0,padding/* blockPadV */.zr)(), ()=>(0,padding/* blockPadH */.XA)());
const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4babb24b-1"
})(AboutItem_templateObject1(), ()=>(0,padding/* blockW */.g5)());
const ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4babb24b-2"
})(AboutItem_templateObject2());
const Title = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-4babb24b-3"
})(_templateObject3());
const Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4babb24b-4"
})(_templateObject5(), (param)=>{
    let { theme  } = param;
    return theme.mq.lg(_templateObject4());
});
const TechsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4babb24b-5"
})(_templateObject8(), (param)=>{
    let { theme  } = param;
    return theme.mq.sm(_templateObject6());
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject7());
});
const GradientBackground = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4babb24b-6"
})(_templateObject10(), (param)=>{
    let { gradient  } = param;
    return gradient;
}, (param)=>{
    let { title  } = param;
    switch(title){
        case "Ecommerce Solutions":
            return "background-position: 50% 50%;";
        case "SaaS Development":
            return "\n          mix-blend-mode: normal;\n        ";
        default:
            return "";
    }
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject9());
});
const AboutItem = (param)=>{
    let { title , styledRichText , technologies  } = param;
    const [gradient, setGradient] = (0,react.useState)("");
    const determineGradient = ()=>{
        switch(title){
            case "Ecommerce Solutions":
                setGradient("linear-gradient(0deg, rgba(16, 19, 82, 0.4), rgba(16, 19, 82, 0.4)), linear-gradient(80deg, rgb(131, 100, 154) 0%, rgb(215,92,84) 100%)");
                break;
            case "Marketing Sites":
                setGradient("linear-gradient(0deg, rgba(16, 19, 82, 0.4), rgba(16, 19, 82, 0.4)), linear-gradient(180deg, #024FB6 0%, #D0BFEC 100%)");
                break;
            case "SaaS Development":
                setGradient("linear-gradient(110.71deg, rgba(47, 171, 156, 0.4) 8.66%, rgba(46, 106, 222, 0.4) 64.62%)");
                break;
            case "Data Visualization":
                setGradient("linear-gradient(180deg, #0D3BBB 0%, #22C2E1 100%)");
                break;
            default:
                return;
        }
    };
    (0,react.useEffect)(()=>determineGradient(), []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientBackground, {
                gradient: gradient,
                title: title || "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRichText/* default */.Z, {
                                pFormat: styledRichText === null || styledRichText === void 0 ? void 0 : styledRichText.pFormat,
                                content: styledRichText === null || styledRichText === void 0 ? void 0 : styledRichText.body
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TechsContainer, {
                            children: technologies === null || technologies === void 0 ? void 0 : technologies.map((tech, i)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(TechItem_TechItem, {
                                    name: (tech === null || tech === void 0 ? void 0 : tech.name) || ""
                                }, "".concat(i, "--").concat(tech === null || tech === void 0 ? void 0 : tech.name));
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var AboutItem_AboutItem = (AboutItem);

;// CONCATENATED MODULE: ./blocks/AboutItem/index.ts



/***/ }),

/***/ 31585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ StyledRichText_StyledRichText; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tinacms/dist/rich-text/index.es.js
var index_es = __webpack_require__(48766);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./components/TinaRichText/TinaRichText.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  li {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}




const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d745d383-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.themeColors.fg;
});
const TinaRichText = (param)=>{
    let { components , content  } = param;
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        className: "rich-text",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* TinaMarkdown */.t, {
            content: content,
            components: components
        })
    });
};
/* harmony default export */ var TinaRichText_TinaRichText = (TinaRichText);

;// CONCATENATED MODULE: ./components/TinaRichText/index.ts


// EXTERNAL MODULE: ./components/FormattedText/index.tsx
var FormattedText = __webpack_require__(89867);
;// CONCATENATED MODULE: ./components/StyledRichText/StyledRichText.tsx




const components = (pFormat)=>{
    return {
        p: (props)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                pFormat: pFormat,
                ...props,
                children: props.children
            });
        },
        a: (props)=>{
            var ref;
            const hostname =  true ? window.location.hostname : 0;
            if ((props === null || props === void 0 ? void 0 : props.url) && (props === null || props === void 0 ? void 0 : (ref = props.url) === null || ref === void 0 ? void 0 : ref.indexOf(hostname)) >= 0) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: props === null || props === void 0 ? void 0 : props.url,
                    ...props,
                    children: props.children
                });
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: props === null || props === void 0 ? void 0 : props.url,
                    target: "_blank",
                    rel: "noreferrer",
                    ...props,
                    children: props.children
                });
            }
        }
    };
};
const StyledRichText = (param)=>{
    let { pFormat ="default" , content  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TinaRichText_TinaRichText, {
        components: components(pFormat),
        content: content
    });
};
/* harmony default export */ var StyledRichText_StyledRichText = (StyledRichText);

;// CONCATENATED MODULE: ./components/StyledRichText/index.tsx



/***/ }),

/***/ 48766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ TinaMarkdown; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const TinaMarkdown = ({
  content,
  components = {}
}) => {
  if (!content) {
    return null;
  }
  const nodes = Array.isArray(content) ? content : content.children;
  if (!nodes) {
    return null;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, nodes.map((child, index) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MemoNode, {
      components,
      key: index,
      child
    });
  }));
};
const Leaf = (props) => {
  if (props.bold) {
    const { bold, ...rest } = props;
    if (props.components.bold) {
      const Component = props.components.bold;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
        ...rest
      }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("strong", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
      ...rest
    }));
  }
  if (props.italic) {
    const { italic, ...rest } = props;
    if (props.components.italic) {
      const Component = props.components.italic;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
        ...rest
      }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("em", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
      ...rest
    }));
  }
  if (props.underline) {
    const { underline, ...rest } = props;
    if (props.components.underline) {
      const Component = props.components.underline;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
        ...rest
      }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("u", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
      ...rest
    }));
  }
  if (props.strikethrough) {
    const { strikethrough, ...rest } = props;
    if (props.components.strikethrough) {
      const Component = props.components.strikethrough;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
        ...rest
      }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("s", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
      ...rest
    }));
  }
  if (props.code) {
    const { code, ...rest } = props;
    if (props.components.code) {
      const Component = props.components.code;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
        ...rest
      }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("code", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
      ...rest
    }));
  }
  if (props.components.text) {
    const Component = props.components.text;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, props.text);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, props.text);
};
const MemoNode = (props) => {
  const MNode = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Node, {
    ...props
  }), [JSON.stringify(props)]);
  return MNode;
};
const Node = ({ components, child }) => {
  const { children, ...props } = child;
  switch (child.type) {
    case "h1":
    case "h2":
    case "h3":
    case "h4":
    case "h5":
    case "h6":
    case "p":
    case "blockquote":
    case "ol":
    case "ul":
    case "li":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, {
          components,
          content: children
        }));
      }
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(child.type, {
        children: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, {
          components,
          content: children
        })
      });
    case "lic":
      if (components.lic) {
        const Component2 = components.lic;
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, {
          components,
          content: children
        }));
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, {
        components,
        content: child.children
      }));
    case "img":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        });
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
        src: child.url,
        alt: child.caption
      });
    case "a":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, {
          components,
          content: children
        }));
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
        href: child.url
      }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, {
        components,
        content: children
      }));
    case "code_block":
      const value = child.value;
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        });
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("pre", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("code", null, value));
    case "hr":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        });
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("hr", null);
    case "break":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        });
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null);
    case "text":
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
        components,
        ...child
      });
    case "mdxJsxTextElement":
    case "mdxJsxFlowElement":
      const Component = components[child.name];
      if (Component) {
        const props2 = child.props ? child.props : {};
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, {
          ...props2
        });
      } else {
        const ComponentMissing = components["component_missing"];
        if (ComponentMissing) {
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ComponentMissing, {
            name: child.name
          });
        } else {
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, `No component provided for ${child.name}`);
        }
      }
    case "maybe_mdx":
      return null;
    case "html":
    case "html_inline":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        });
      }
      return child.value;
    case "invalid_markdown":
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("pre", null, child.value);
    default:
      if (typeof child.text === "string") {
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
          components,
          ...child
        });
      }
  }
};



/***/ })

}]);